var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.4 25.8",
    style: {
      enableBackground: "new 0 0 87.4 25.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\r\n\t.st0{fill:#17191C;}\r\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    className: "st0",
    points: "14.3,8.6 15.8,4.9 23.9,24.3 21,24.3 18.6,18.6 10.2,18.6 11.3,16.1 17.4,16.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st0",
    points: "16.8,21.6 17.8,24.3 2,24.3 11.5,1.4 14.6,1.4 6.3,21.6  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_208_",
    className: "st0",
    d: "M31,19.9V5.9h1.6v12.6h6.2v1.5H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_206_",
    className: "st0",
    d: "M51.6,5.9v9.1c0,1.6-0.5,2.9-1.5,3.8c-1,0.9-2.3,1.4-4,1.4c-1.7,0-3-0.5-3.9-1.4 c-0.9-0.9-1.4-2.2-1.4-3.8V5.9h1.6V15c0,1.2,0.3,2.1,1,2.7c0.6,0.6,1.6,0.9,2.8,0.9c1.2,0,2.1-0.3,2.7-0.9c0.6-0.6,1-1.5,1-2.7 V5.9H51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_204_",
    className: "st0",
    d: "M61.4,7.1c-1.5,0-2.8,0.5-3.7,1.5c-0.9,1-1.3,2.4-1.3,4.2c0,1.8,0.4,3.3,1.3,4.3 c0.9,1,2.1,1.5,3.7,1.5c1,0,2.1-0.2,3.4-0.5v1.4c-1,0.4-2.2,0.5-3.6,0.5c-2.1,0-3.7-0.6-4.8-1.9s-1.7-3-1.7-5.4 c0-1.4,0.3-2.7,0.8-3.8C56,8,56.8,7.1,57.8,6.5c1-0.6,2.2-0.9,3.6-0.9c1.5,0,2.8,0.3,3.9,0.8l-0.7,1.4C63.5,7.4,62.4,7.1,61.4,7.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_202_",
    className: "st0",
    d: "M67.8,19.9V5.9h1.6v14.1H67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_199_",
    className: "st0",
    d: "M84.5,12.7c0,2.3-0.6,4.1-1.9,5.3c-1.3,1.2-3.1,1.8-5.4,1.8h-3.9V5.9h4.3 c2.2,0,3.9,0.6,5.1,1.8S84.5,10.6,84.5,12.7z M82.8,12.8c0-1.8-0.5-3.2-1.4-4.1c-0.9-0.9-2.3-1.4-4.1-1.4h-2.4v11.2h2 c1.9,0,3.4-0.5,4.4-1.4S82.8,14.7,82.8,12.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5d9e4fc8d229e83ba2bee55a6b981eba.svg";
export { ForwardRef as ReactComponent };